import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { LocaleProvider } from './i18n';
import { PwaLifecycle } from './pwa/PwaLifecycle';
import { UnsavedChangesProvider } from './unsaved-changes';
import './styles.css';
import './foundation.css';
import './entity-ux.css';
import './domain.css';
import './dish-assembly.css';
import './version-governance.css';
import './mobile-domain-switcher.css';
import './account.css';
import './membership.css';
import './invitation-verification.css';
import './shell.css';
import './workspace-switcher.css';
import './library.css';
import './workspace-reuse.css';
import './detail.css';
import './menu.css';
import './workbench.css';
import './ingredients.css';
import './recipe-composition.css';
import './recipe-entry.css';
import './kitchen-sheet.css';
import './context-tools.css';
import './scaling.css';
import './kitchen-tools.css';
import './allergens.css';
import './rnd-lineage.css';
import './culinary-locales.css';
import './media.css';
import './imports.css';
import './import-source-chooser.css';
import './import-review-navigator.css';
import './import-review-round20.css';
import './import-translation.css';
import './import-tree.css';
import './exports.css';
import './export-center.css';
import './export-simplification.css';
import './recycle.css';
import './operational.css';
import './permissions.css';
import './illustrations.css';
import './motion.css';
import './pwa.css';
import './offline-draft.css';
import './task-system.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <LocaleProvider>
      <UnsavedChangesProvider>
        <PwaLifecycle />
        <App />
      </UnsavedChangesProvider>
    </LocaleProvider>
  </StrictMode>
);
import './experience-foundation.css';
